// ===========================================================
// ERP EXPORT MODULE (PDF & Excel)
// ===========================================================

// Export to PDF
window.exportToPDF = function(modType) {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF('l', 'mm', 'a4');
  const data = UI_DATA[modType.toLowerCase()] || [];
  const brand = (window.Shopify ? window.Shopify.shop : 'Store').split('.')[0].replace(/-/g, ' ').toUpperCase();
  
  doc.setFontSize(20);
  doc.setTextColor(37, 99, 235);
  doc.text(`${brand} - ${modType} Report`, 14, 20);
  
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);
  
  let head = [], body = [], foot = [];
  
  if (modType.toLowerCase() === 'inventory') {
    head = [["Product", "Vendor", "SKU", `Price (${SHOP_CURRENCY})`, "Stock"]];
    let sum = 0;
    body = data.flatMap(p => p.variants.map(v => {
      sum += (v.inventory_quantity || 0);
      return [p.title, p.vendor, v.sku || 'N/A', v.price, v.inventory_quantity];
    }));
    foot = [['', '', '', 'TOTAL UNITS:', sum]];
    
  } else if (modType.toLowerCase() === 'orders') {
    head = [["Order", "Customer", "Phone", "Status", `Amount (${SHOP_CURRENCY})`]];
    let sum = 0;
    body = data.map(o => {
      sum += parseFloat(o.total_price || 0);
      return [o.name, o.customer?.first_name || 'Guest', o.customer?.phone || 'N/A', o.financial_status, o.total_price];
    });
    foot = [['', '', '', 'TOTAL SALES:', sum.toFixed(2)]];
    
  } else if (modType.toLowerCase() === 'customers') {
    head = [["Customer Name", "Email", "Phone", `Total Spent (${SHOP_CURRENCY})`]];
    let sum = 0;
    body = data.map(c => {
      sum += parseFloat(c.total_spent || 0);
      const p = c.phone || (c.default_address ? c.default_address.phone : 'N/A');
      return [`${c.first_name} ${c.last_name}`, c.email, p, c.total_spent];
    });
    foot = [['', '', 'GRAND TOTAL:', sum.toFixed(2)]];
  }
  
  doc.autoTable({
    startY: 35,
    head: head,
    body: body,
    foot: foot,
    theme: 'striped',
    headStyles: { fillColor: [37, 99, 235] },
    footStyles: { fillColor: [241, 245, 249], textColor: 0, fontStyle: 'bold' }
  });
  
  doc.save(`${brand}_${modType}_${Date.now()}.pdf`);
};

// Export to Excel (CSV)
window.exportToExcel = function(modType) {
  const data = UI_DATA[modType.toLowerCase()] || [];
  let csv = "data:text/csv;charset=utf-8,";
  let rows = [];
  
  if (modType.toLowerCase() === 'inventory') {
    rows.push(["Product", "Vendor", "SKU", "Price", "Stock"]);
    let sum = 0;
    data.forEach(p => p.variants.forEach(v => {
      sum += (v.inventory_quantity || 0);
      rows.push([p.title, p.vendor, v.sku, v.price, v.inventory_quantity]);
    }));
    rows.push(["", "", "", "TOTAL UNITS", sum]);
    
  } else if (modType.toLowerCase() === 'orders') {
    rows.push(["Order", "Customer", "Phone", "Status", "Amount"]);
    let sum = 0;
    data.forEach(o => {
      sum += parseFloat(o.total_price);
      rows.push([o.name, o.customer?.first_name, o.customer?.phone, o.financial_status, o.total_price]);
    });
    rows.push(["", "", "", "TOTAL SALES", sum.toFixed(2)]);
  }
  
  rows.forEach(r => csv += r.join(",") + "\r\n");
  
  const link = document.createElement("a");
  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", `${modType}_Report.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};